// BaseContext.js — tenant context (product noun: Base; wire field: baseKey)
import React, { createContext, useContext, useMemo, useState } from 'react';

export const BaseContext = createContext();

export const useBase = () => {
  const context = useContext(BaseContext);
  if (!context) {
    throw new Error('useBase must be used within a BaseProvider');
  }
  return context;
};

export const BaseProvider = ({ children }) => {
  const [activeBase, setActiveBase] = useState(null);
  const value = useMemo(() => ({
    activeBase,
    setActiveBase,
  }), [activeBase]);
  return (
    <BaseContext.Provider value={value}>
      {children}
    </BaseContext.Provider>
  );
};
